import React from 'react';

const FormField = ({ label, required, error, children, description }) => {
  return (
    <div className="w-full mb-4 md:mb-5 lg:mb-6">
      {label && (
        <label className="block text-sm md:text-base font-medium text-foreground mb-1.5 md:mb-2">
          {label}
          {required && <span className="text-error ml-1">*</span>}
        </label>
      )}
      {description && (
        <p className="text-xs md:text-sm text-muted-foreground mb-2">
          {description}
        </p>
      )}
      {children}
      {error && (
        <p className="text-xs md:text-sm text-error mt-1.5" role="alert">
          {error}
        </p>
      )}
    </div>
  );
};

export default FormField;